import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from './sections/NavBar';
import { Banner } from './sections/Banner';
import { AppStore } from './sections/AppStore';
import { Experience } from "./sections/Experience";
import { Contact } from "./sections/Contact";
import { Footer } from "./sections/Footer";
import { DialogProvider } from "./components/DialogProvider";

function App() {
    return (
        <DialogProvider>
            <div className="App">
                <NavBar />
                <Banner />
                <AppStore />
                <Experience />
                <Contact />
                <Footer />
            </div>
        </DialogProvider>
    );
}

export default App;
